module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Wird konvertiert":"Wird konvertiert","Konvertierung fehlgeschlagen":"Konvertierung fehlgeschlagen","Erneut versuchen":"Erneut versuchen"},"en":{"Wird konvertiert":"Converting","Konvertierung fehlgeschlagen":"Conversion failed","Erneut versuchen":"Retry"}}')
  delete Component.options._Ctor
}
